<div class="overlay"></div>
<div class="modal">
    <div class="logo-container">
        <img src="../../../assets/login/logo.png" alt="Datacore Logo" />
        <button class="close-btn" (click)="close()">✕</button>
    </div>

    <div class="header">
        <h2>{{ 'login.header.title' | translate }}</h2>
        <p>
            {{ 'login.header.subtitle' | translate }}
        </p>
    </div>

    <form (ngSubmit)="onSubmit()" class="form">
        <label>{{ 'login.form.usernameLabel' | translate }}</label>
        <input
            type="text"
            placeholder="{{ 'login.form.usernamePlaceholder' | translate }}"
            [(ngModel)]="username"
            name="username"
            required
            [class.fail]="loginStatus"
        />
        <span class="wrong-text" *ngIf="loginStatus">{{ 'login.form.usernameError' | translate }}</span>

        <label>{{ 'login.form.passwordLabel' | translate }}</label>
        <div class="password-wrapper">
            <input
                [type]="showPassword ? 'text' : 'password'"
                placeholder="{{ 'login.form.passwordPlaceholder' | translate }}"
                [(ngModel)]="password"
                name="password"
                required
                [class.fail]="loginStatus"
            />
            <button type="button" class="toggle" (click)="togglePassword()">
                <i
                    [ngClass]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"
                ></i>
            </button>
        </div>
        <span class="wrong-text" *ngIf="loginStatus">{{ 'login.form.passwordError' | translate }}</span>

        <div class="form-options">
            <label>
                <input type="checkbox" [(ngModel)]="remember" name="remember" />
                {{ 'login.form.remember' | translate }}
            </label>
            <a (click)="forgotPassword()">{{ 'login.form.forgotPassword' | translate }}</a>
        </div>

        <button
            (click)="login()"
            type="submit"
            class="login-btn"
            [disabled]="!username || !password"
        >
            <span *ngIf="!isLoading">{{ 'login.form.loginButton' | translate }}</span>
            <span *ngIf="isLoading" class="spinner"></span>
        </button>

        <p class="signup">{{ 'login.form.signupText' | translate }}<a (click)="signUp()"> {{ 'login.form.signupLink' | translate }}</a></p>

        <div class="divider">
            <span>{{ 'login.form.or' | translate }}</span>
        </div>

        <button type="button" class="google-btn" (click)="loginWithGoogle()">
            <img
                src="assets/icons/icon-google.svg"
                alt="Google"
            />
            {{ 'login.form.google' | translate }}
        </button>

        <p class="footer">
            {{ 'login.footer.before' | translate
            }}<a [routerLink]="['/', lang, RouterPath.DOCS, RouterPath.TERMS]" target="_blank" rel="noopener">{{ 'login.footer.terms' | translate }}</a>{{ 'login.footer.middle' | translate
            }}<a [routerLink]="['/', lang, RouterPath.DOCS, RouterPath.POLICY]" target="_blank" rel="noopener">{{ 'login.footer.privacy' | translate }}</a>{{ 'login.footer.after' | translate }}
        </p>
    </form>
</div>
